import { routes } from '@/app/routing/router'
import { TonConnectPageWiew } from './veiw'

const currentRoute = routes.tonConnect

const TonConnectPageRoute = {
  route: currentRoute,
  view: TonConnectPageWiew,
}

export { currentRoute, TonConnectPageRoute }
